import * as bi from 'react-bootstrap-icons';
import { IClientPassengerBrief, ClientPassengerDocumentStatus } from '@bustickus/models-client';
import { Box, Flex } from 'components';
import './style.scss';

interface IProps {
  passenger: IClientPassengerBrief;
}

function PassengerDocument(props: { title: string; status: ClientPassengerDocumentStatus }) {
  return (
    <Flex
      gap={5}
      className='doc-state-GltJ'
    >
      <div className={`doc-icon-kkg8 ${getDocumentStatusClassName(props.status)}`}>
        <bi.Passport />
      </div>
      <Flex direction='column'>
        <div>{props.title}</div>
        <div className={`doc-text-GsHu ${getDocumentStatusClassName(props.status)}`}>
          {getDocumentStatusText(props.status)}
        </div>
      </Flex>
    </Flex>
  );
}

function getDocumentStatusText(status: ClientPassengerDocumentStatus) {
  if (status === 'ok') {
    return 'Документ заполнен';
  }

  if (status === 'expired') {
    return 'Действие документа истекло или истекает!';
  }

  if (status === 'none') {
    return 'Документ не заполнен!';
  }

  return 'Статус документа неизвестен';
}

function getDocumentStatusClassName(status: ClientPassengerDocumentStatus) {
  if (status === 'ok') {
    return 's-mGZN3';
  }

  if (status === 'expired') {
    return 'e-LCxSh';
  }

  if (status === 'none') {
    return 'e-LCxSh';
  }

  return 'w-nXllz';
}

function PassengerDocuments(props: IProps) {
  return (
    <Box
      shadow='inside'
      variant='darker'
      padding={10}
    >
      <Flex
        direction='column'
        gap={10}
      >
        {props.passenger.passport != null && (
          <PassengerDocument
            status={props.passenger.passport}
            title='Паспорт Российской Федерации'
          />
        )}
        {props.passenger.foreignPassport != null && (
          <PassengerDocument
            status={props.passenger.foreignPassport}
            title='Заграничный паспорт'
          />
        )}
        {props.passenger.visas?.map((x) => (
          <PassengerDocument
            key={x.visaId}
            title={x.visaName}
            status={x.status}
          />
        ))}
      </Flex>
    </Box>
  );
}

export default PassengerDocuments;
